import {configureStore} from '@reduxjs/toolkit';
import {Provider as ReduxProvider} from 'react-redux';
import reducer from './store/reducer';
import App from './App';
import {ConfigProvider} from "./context/ConfigProvider";
import {LocalStoreProvider} from "./context/LocalStoreProvider";
import {ToastProvider} from "../common/fusion-ui/provider/ToastProvider";
import {ProjectThemeProvider} from "../common/ProjectThemeProvider";
import {AdminAuthProvider} from "./context/AdminAuthProvider";
import {ThemeNames} from "../common/CommonConfig";
import './assets/scss/style.scss';
import './assets/css/admin_styles.css';
import React from "react";

const store = configureStore({reducer});

export default function AdminRoot() {
    return <ReduxProvider store={store}>
        <AdminAuthProvider>
            <LocalStoreProvider>
                <ProjectThemeProvider themeName={ThemeNames.ROYAL_BLUE}>
                    <ToastProvider>
                        <ConfigProvider>
                            <App/>
                        </ConfigProvider>
                    </ToastProvider>
                </ProjectThemeProvider>
            </LocalStoreProvider>
        </AdminAuthProvider>
    </ReduxProvider>
}
